import Vue from 'vue'

import Router from 'vue-router'
import Store from '@/stores/store.js'
import Data from '@/data/data.js'

import About from '@/views/About.vue'

import Directors from '@/views/Directors.vue'
import DirectorsSingle from '@/views/DirectorsSingle.vue'

import News from '@/views/News.vue'
import NewsSingle from '@/views/NewsSingle.vue'

import NotFound from '@/views/NotFound.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
        path: '/',
        name: 'home',
    },
    {
        path: '/about',
        name: 'about',
        component: About,
    },
    /*
    {
        path: '/news',
        name: 'news',
        component: News,
        children: [
            {
                path: ':slug',
                name: 'newsSingle',
                component: NewsSingle,
                beforeEnter: (to, from, next) =>{
                    Data.getNewsBySlug(to.params.slug).then( (news) =>{
                        Store.state.currentNews = news;
                        next();
                    })
                },
            }
        ]
    },
    */
    {
        path: '/directors',
        name: 'directors',
    },
    {
        path: '/news',
        name: 'news',
    },
    {
        path: '/directors/:slug',
        name: 'directorsSingle',
        component: DirectorsSingle,
        beforeEnter: (to, from, next) => {
            Data.getDirectorBySlug(to.params.slug).then((director) => {
                Store.state.currentDirector = director;
                next();
            })
        },
    },
    {
        path: '/news/:slug',
        name: 'newsSingle',
        component: NewsSingle,
        beforeEnter: (to, from, next) => {
            Data.getNewsBySlug(to.params.slug).then( (news) =>{
                Store.state.currentNews = news;
                next();
            })
        },
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
  },
  ]
})

router.afterEach((to, from) => {
    if(to.name == "home"){
        Store.state.level = 0;
        Store.state.notFound = false
    } else if (to.name == 'directors' || to.name == 'news' || to.name == 'about' ){
        Store.state.level = 1
        Store.state.notFound = false
    }else if (to.name == 'NotFound'){
        Store.state.level = 1
        Store.state.notFound = true
    }else{
        Store.state.level = 2
        Store.state.notFound = false
    }

    if( Store.state.level -1 <=0 ){
        Store.state.currentDirector = null;
        Store.state.currentNews = null;
    }
    
    Store.state.route = to.name
    
})

export default router;